import {styledByTheme} from "../../../../../themes/architecture/styled-by-theme";
import {HeaderWelcomeButtonsContainerDefaultBox} from "./header-welcome-buttons-container.default.box";
import {HeaderWelcomeButtonsContainerHarrahsBox} from "./header-welcome-buttons-container.harrahs.box";
import {HeaderWelcomeButtonsContainerSiBox} from "./header-welcome-buttons-container.si.box";

export const HeaderWelcomeButtonsContainerBox = styledByTheme(HeaderWelcomeButtonsContainerDefaultBox)
    .forHarrahs(HeaderWelcomeButtonsContainerHarrahsBox)
    .forSI(HeaderWelcomeButtonsContainerSiBox)
    .apply();
